import { object as yupObject, string as yupString, bool as yupBool } from 'yup';

export const validationSchema = () =>
  yupObject().shape({
    statusEmployee: yupString().required('Field cannot be empty'),
    isEmployerRelative: yupBool(),
    relationshipParentWithEmployerDenote: yupString()
      .nullable()
      .test({
        name: 'relationship-required',
        message: 'Field cannot be empty',
        test: function (value) {
          const { isEmployerRelative } = this.parent;
          if (isEmployerRelative) {
            return (
              value !== null && value !== undefined && value.trim().length > 0
            );
          }
          return true;
        },
      }),
    isHandicapped: yupBool(),
  });
